<form
  [formGroup]="listDetailsForm"
  (ngSubmit)="onSubmit()"
  novalidate
  #listDetailsFormRef="ngForm"
>
  <div class="modal-body" *ngIf="modalControl?.isShown">
    <div
      *ngIf="modalControl.savingError ? true : false"
      class="alert alert-danger qa-edit-details-error"
      role="alert"
    >
      <strong i18n="@@listDetailsEditor-status-error">Error!</strong>
      <ng-container i18n="@@listDetailsEditor-status-errorPleaseRetry"
        >There was an error saving list details. Please try again.</ng-container
      >
    </div>

    <div
      *ngIf="validationErrors().length > 0 && listDetailsFormRef.submitted"
      class="alert alert-danger qa-edit-details-validation"
      role="alert"
    >
      <div i18n="@@listDetailsEditor-validation-panelHeading">
        Errors prevented the list details from being saved:
      </div>
      <ul>
        <li
          *ngIf="listDetailsForm.controls.title.errors?.required"
          i18n="@@listDetailsEditor-title-required"
          class="qa-edit-details-blank-title"
        >
          Title can't be blank
        </li>
        <li
          *ngIf="listDetailsForm.controls.title.errors?.pattern"
          i18n="@@listDetailsEditor-title-pattern"
          class="qa-edit-details-invalid-title"
        >
          Title must contain at least one non-whitespace character
        </li>
        <li
          *ngIf="listDetailsForm.controls.description.errors?.pattern"
          i18n="@@listDetailsEditor-description-pattern"
          class="qa-edit-details-invalid-description"
        >
          Description must contain at least one non-whitespace character
        </li>
        <li
          *ngIf="listDetailsForm.controls.internalNote.errors?.pattern"
          i18n="@@listDetailsEditor-internalNote-pattern"
          class="qa-edit-details-invalid-internal-note"
        >
          Internal note must contain at least one non-whitespace character
        </li>
      </ul>
    </div>

    <div class="form-group">
      <label class="form-label" for="listDetailsEditor-form-title"
        ><ng-container i18n="@@listDetailsEditor-title-label"
          >Title</ng-container
        >
        <span
          class="field-required"
          i18n="@@listDetailsEditor-title-required-hint"
          >(Required)</span
        >
        <span
          class="field-hint"
          i18n="@@listDetailsEditor-title-label-titleMaxLengthHint"
        >
          Maximum 100 characters
        </span>
      </label>
      <input
        rlAutofocus
        type="text"
        class="form-control qa-edit-details-title"
        id="listDetailsEditor-form-title"
        name="title"
        formControlName="title"
        required
        [attr.aria-describedby]="
          (listDetailsForm.controls.title.dirty ||
            listDetailsForm.controls.title.touched) &&
          listDetailsForm.controls.title.errors
            ? 'listDetailsEditor-form-title__errors'
            : null
        "
      />
      <div
        class="indicator help-block qa-title-help-block"
        role="status"
        aria-live="polite"
        i18n="@@listDetailsEditor-title-charactersRemaining"
      >
        {titleCharactersRemaining, plural, =1 {You have 1 character remaining.}
        other {You have {{ titleCharactersRemaining }} characters remaining.}}
      </div>
      <div
        *ngIf="
          listDetailsForm.controls.title.errors && listDetailsFormRef.submitted
        "
        class="field-error qa-title-inline-errors"
        id="listDetailsEditor-form-title__errors"
        role="alert"
      >
        <span
          *ngIf="listDetailsForm.controls.title.errors?.required"
          i18n="@@listDetailsEditor-title-error__required"
          >Title can't be blank</span
        >
        <span
          *ngIf="listDetailsForm.controls.title.errors?.pattern"
          i18n="@@listDetailsEditor-title-error__pattern"
          >Title must contain at least one non-whitespace character</span
        >
      </div>
    </div>

    <div class="form-group">
      <label class="form-label" for="listDetailsEditor-form-description"
        ><ng-container i18n="@@listDetailsEditor-description-label"
          >Description</ng-container
        >
        <span class="help-block" i18n="@@listDetailsEditor-description-hint">
          Visible to list editors, library staff, and (once published) students
        </span></label
      >
      <textarea
        class="form-control qa-edit-details-description"
        id="listDetailsEditor-form-description"
        name="description"
        rows="3"
        formControlName="description"
        [attr.aria-describedby]="
          (listDetailsForm.controls.description.dirty ||
            listDetailsForm.controls.description.touched) &&
          listDetailsForm.controls.description.errors
            ? 'listDetailsEditor-form-description__errors'
            : null
        "
      >
      </textarea>
      <div
        *ngIf="
          listDetailsForm.controls.description.errors?.pattern &&
          listDetailsFormRef.submitted
        "
        id="listDetailsEditor-form-description__errors"
        class="field-error qa-description-inline-errors"
      >
        <span i18n="@@listDetailsEditor-description-inline-error-whitespace"
          >Description must contain at least one non-whitespace character</span
        >
      </div>
    </div>

    <div class="form-group">
      <label class="form-label" for="listDetailsEditor-form-internalNote"
        ><ng-container i18n="@@listDetailsEditor-internalNote-label"
          >Internal note</ng-container
        >
        <span class="help-block" i18n="@@listDetailsEditor-internalNote-hint">
          Visible to list editors and library staff
        </span></label
      >
      <textarea
        class="form-control qa-edit-details-internal-note"
        id="listDetailsEditor-form-internalNote"
        name="internalNote"
        rows="3"
        formControlName="internalNote"
        [attr.aria-describedby]="
          (listDetailsForm.controls.internalNote.dirty ||
            listDetailsForm.controls.internalNote.touched) &&
          listDetailsForm.controls.internalNote.errors
            ? 'listDetailsEditor-form-internalNote__errors'
            : null
        "
      >
      </textarea>
      <div
        *ngIf="
          listDetailsForm.controls.internalNote.errors?.pattern &&
          listDetailsFormRef.submitted
        "
        id="listDetailsEditor-form-internalNote__errors"
        class="field-error qa-internal-note-inline-errors"
      >
        <span i18n="@@listDetailsEditor-internalNote-inline-error-whitespace"
          >Internal note must contain at least one non-whitespace
          character</span
        >
      </div>
    </div>

    <div
      *ngIf="canAssignLicenses"
      class="form-group qa-edit-details-licenses-group"
    >
      <label
        class="form-label"
        for="listDetailsEditor-form-license"
        i18n="@@listDetailsEditor-license-label"
        >Set license</label
      >

      <select
        class="form-select qa-edit-details-licenses"
        id="listDetailsEditor-form-license"
        name="license"
        formControlName="license"
        [compareWith]="licenseComparator"
      >
        <!-- Option of null means different things depending on whether the tenant has a default license set -->
        <option
          *ngIf="!tenantDefaultLicense"
          [ngValue]="null"
          i18n="@@listDetailsEditor-license-option-none"
        >
          None
        </option>
        <option
          *ngIf="tenantDefaultLicense"
          [ngValue]="null"
          i18n="@@listDetailsEditor-license-option-useDefault"
        >
          Use default license
        </option>
        <option *ngFor="let license of licenses" [ngValue]="license">
          {{ license.title }}
          <ng-container
            *ngIf="license.is_tenant_default"
            i18n="@@listDetailsEditor-license-default"
            >(default)</ng-container
          >
        </option>
      </select>
    </div>

    <div class="form-group">
      <label
        class="form-label"
        for="listDetailsEditor-form-timePeriod"
        i18n="@@listDetailsEditor-timePeriod-label"
        >Time period</label
      >

      <div class="row">
        <div class="col-xs-6">
          <select
            class="form-select qa-edit-details-periods"
            id="listDetailsEditor-form-timePeriod"
            name="timePeriod"
            formControlName="timePeriod"
            [compareWith]="timePeriodComparator"
          >
            <option
              [ngValue]="null"
              i18n="@@listDetailsEditor-timePeriod-option-none"
            >
              None
            </option>
            <option
              *ngFor="let timePeriod of timePeriods"
              [ngValue]="timePeriod"
            >
              {{ timePeriod.description }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div *ngIf="canSetPrivacy" class="form-group qa-edit-details-access-group">
      <label
        class="form-label"
        for="listDetailsEditor-form-listAccess"
        i18n="@@listDetailsEditor-access-label"
        >Who can view</label
      >

      <div class="row">
        <div class="col-xs-6">
          <select
            class="form-select qa-edit-details-access"
            id="listDetailsEditor-form-listAccess"
            name="listAccess"
            formControlName="listAccess"
          >
            <option
              i18n="@@listDetailsEditor-access-option-institutionDefault"
              [ngValue]="null"
            >
              Institution default
            </option>
            <option
              i18n="@@listDetailsEditor-access-option-everyone"
              [value]="ListAccess.PUBLIC"
            >
              Everyone
            </option>
            <option
              i18n="@@listDetailsEditor-access-option-onlyLoggedInUsers"
              [value]="ListAccess.PRIVATE"
            >
              Only logged in users
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer" *ngIf="modalControl?.isShown">
    <button
      [disabled]="modalControl.isSaving"
      (click)="onCancel()"
      type="button"
      class="btn btn-default qa-edit-details-cancel"
    >
      <ng-container i18n="@@listDetailsEditor-btn-cancel">Cancel</ng-container>
    </button>

    <button
      [disabled]="modalControl.isSaving"
      type="submit"
      class="btn btn-primary qa-edit-details-save"
    >
      <ng-container *ngIf="modalControl.isSaving">
        <span class="text-center qa-edit-details-saving" role="status">
          <i class="fas fa-spinner-third fa-fw fa-spin" aria-hidden="true"></i>
          <span class="sr-only" i18n="@@listDetailsEditor-spinner-saving"
            >Saving...</span
          >
        </span>
      </ng-container>

      <ng-container i18n="@@listDetailsEditor-btn-save">Save</ng-container>
    </button>
  </div>
</form>
